import { Skeleton } from 'primereact/skeleton';
import { useEffect, useState } from 'react';
const ChartSkeleton = ({model}) => {
    const [list, setList]=useState([])
    useEffect(()=>{
        
        switch (model) {
            case 'gas':
                setList(["CO2","CH4","N2O","HFCs","PFCs","SF6","NF3"])
                break;
            case 'category':
                setList(["","","",""])
                break;
        
            default:
                break;
        }
        },[model]
    )

    return(
        <div className='dashboard-dount-chart-skeleton'>
        <Skeleton shape="circle" size="300px">
            <span className='circle'></span>
        </Skeleton>
    
        <div className='element-info'>
            {list.map((ele,key)=>{
                return(
                    <div className='item' key={key}>
                        <Skeleton width="30px" height="1rem"></Skeleton>
                        <span className={ele===''?'line-text-skeleton':''}>{ele}</span>    
                    </div>
                )
            })
            }
        </div>
    </div>
    )
}
export default ChartSkeleton;